import { useEffect, useState } from "react"
import { Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useApi } from "../../../api"
import { ErrorResponseDialog } from "../../../components/ErrorResponseDialog"
import { ImageUploader } from "../../../components/ImageUploader"
import { SuccessDialog } from "../../../components/SuccessDialog"
import { ICargo, ISeries } from "../../../interfaces"
import { Utils } from "../../../utils"
import { Button } from "react-bootstrap"
import { NftShortcut } from "../../../components/NFT/NftShortcut"

export const NftMintPage = () => {
  const projectCode = 'NFT'
  const api = useApi(projectCode)
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [isLoading, setLoading] = useState(false)
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [image, setImage] = useState('')

  const [series, setSeries] = useState<ISeries[]>()
  const [selectedSeries, setSelectedSeries] = useState<ISeries>()

  useEffect(() => {
    const memberNo = localStorage.getItem('memberNo');
    if (!memberNo) return;
    if (series) return;
    setSeries([])
    api.getNftSeries(memberNo, (cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setSeries(cargo.info)
      }
    })
  }, [api, series])

  useEffect(() => {
    if (!Utils().isLogin()) {
      navigate(`/web/login/${projectCode}`)
    }
    Utils().checkKyc();
  }, [api, navigate])

  return (
    <>
      <div className="bg-white p-3 mx-auto" style={{maxWidth: '500px'}}>
        <NftShortcut />
        <div className='pt-5'>
          <ImageUploader projectCode={projectCode} onUploaded={(cargo: ICargo) => {
            if (cargo.returnCode === '000000') {
              setImage(cargo.info['file'])
            }
          }}></ImageUploader>
          <div className="text-center p-1 text-gray-500">請上傳NFT圖片</div>
        </div>
        <div className="mt-4">
          <div className="text-gray-500">NFT名稱</div>
          <input className="border-1 p-2 rounded-md w-full" onChange={(e) => {
            setName(e.target.value)
          }} />
        </div>
        <div className="mt-4">
          <div className="text-gray-500">NFT簡介</div>
          <textarea className="border-1 p-2 rounded-md w-full" rows={9} onChange={(e) => {
            setDescription(e.target.value)
          }}></textarea>
        </div>
        <div className="mt-4">
          <Menu>
            <MenuButton as={Button}>
              {selectedSeries ? selectedSeries.title : '請選擇系列'}
            </MenuButton>
            <MenuList>
              {
                series?.map((item, index) => {
                  return <MenuItem key={index} onClick={() => {
                    setSelectedSeries(item);
                  }}>{item.title}</MenuItem>
                })
              }
            </MenuList>
          </Menu>
        </div>
        <ul className="nav nav-pills">
          <li className="nav-item w-100 px-0">
            <Button className="btn bt-buy border-0 btn-block mt-4 w-100" disabled={isLoading} onClick={() => {
              setLoading(true)
              api.mintNftAssets(name, description, image, selectedSeries?.idNftSeries, (cargo: ICargo) => {
                setLoading(false)
                if (cargo.returnCode === '000000') {
                  SuccessDialog({ title: t('mintSuccess') })
                } else {
                  ErrorResponseDialog(cargo, t)
                }
              })
            }}>{isLoading ? t('processing') : '開始鑄造 NFT'}</Button>
          </li>
        </ul>
        <div className="m-86"></div>
      </div>
    </>

  )
}